import { REVIEWS_FETCH_SUCCESS } from '../constant/actionType';

const initialState = {
  isLoaded: false,
  reviews: []
};

const reviewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REVIEWS_FETCH_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        reviews: action.data
      };
    default:
      return state;
  }
};

export default reviewsReducer;
